import { FC, useMemo } from 'react';
import { CircularProgress, Stack, Typography } from '@mui/material';
import { StarOutline } from '@mui/icons-material';
import { useGetAssociateChatRating } from '@vs-online-only-app/state';

const ChatRating: FC = () => {
  const { data, isLoading } = useGetAssociateChatRating();

  const rating = useMemo(() => {
    if (isLoading) return <CircularProgress size={12} color="warning" />;
    const averageRating = data?.averageRating;
    return (
      <Typography color="warning" fontWeight="bold">
        {averageRating ? averageRating.toFixed(2) : 'No ratings yet'}
      </Typography>
    );
  }, [data?.averageRating, isLoading]);

  return (
    <Stack direction="row" gap={0.5} alignItems="center">
      <Typography>Your chat rating</Typography>
      <StarOutline color="warning" />
      {rating}
    </Stack>
  );
};

export default ChatRating;
